module.exports = __webpack_public_path__ + "static/media/TG.4f66c697.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TG.svg
// module id = 371
// module chunks = 0